<footer>
    <p>
        {{ 'site_only_for_adult_footer' | translate }}
        <a routerLink="/rules">{{ 'site_only_for_adult_footer_rules' | translate }}</a>
        {{ 'site_only_for_adult_footer_and' | translate }}
        <a routerLink="/privacy_policy">{{ 'site_only_for_adult_footer_privacy_policy' | translate }}</a>
    </p>
    @if (landings.length) {
        <p class="footer-landings">
            @for (landing of landings; track landing.slug) {
                <a [routerLink]="'/' + landing.slug">{{ landing.title }}</a>
                @if (!$last) {
                    |
                }
            }
        </p>
    }
    <p>
        @if (showBlog) {
            <a routerLink="/blog">{{ 'blog_title' | translate }}</a>
            |
        }
        @if (showQ_A) {
            <a routerLink="/qa">{{ 'qa' | translate }}</a>
            |
        }
        <a routerLink="/contacts">{{ 'contacts' | translate }}</a>
        |
        <a routerLink="/rules">{{ 'rules_title' | translate }}</a>
        |
        <a routerLink="/privacy_policy">{{ 'privacy_policy' | translate }}</a>
    </p>
</footer>
